import { useMemo } from 'react'
import { BrandPlanIntegrations } from 'types'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { getProviderTacticsAndPlatforms } from 'components/TacticIntegrationList/utils'
import { getNormalizedTactics, normalizeTactic } from './utils'

export const useIntegrationTactics = ({ enabled = true }: { enabled?: boolean } = {}): BrandPlanIntegrations[] => {
  const { data: brandPlan } = useCurrentBrandPlan()
  const { data: integrations } = useExternalIntegrations({ enabled })

  const tacticsInBrandPlan = useMemo(() => getNormalizedTactics(brandPlan), [brandPlan])

  return useMemo(() => {
    const externalIntegrations = integrations?.external_integrations || []
    const connectedTactics = new Set<BrandPlanIntegrations>(tacticsInBrandPlan)

    externalIntegrations.forEach((integration) => {
      const associatedTactics = getProviderTacticsAndPlatforms(integration.provider)
      associatedTactics.tactics.forEach((tactic) => {
        connectedTactics.add(normalizeTactic(tactic))
      })
    })

    return Array.from(connectedTactics)
  }, [tacticsInBrandPlan, integrations?.external_integrations])
}
